import React, { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { api } from '../../../redux/api';
import { Button, Dialog, DialogTitle, DialogActions, DialogContent, CircularProgress } from '@mui/material';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { treeActions } from '../../../redux/slices/treeSlice';
import { newTemplateActions } from '../../../redux/slices/newTemplateSlice';
import LabeledCheckbox from '../../TemplateProperties/TPCheckbox';
function DeleteWorkflowGroup(props) {
    const { openModal, toggle } = props;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { account } = useSelector(state => state.queryParams);
    const parentScreen = useContext(ParentScreenCtx);
    // const workflowName = useSelector(store => store.treeData.leftTree.tree.body.selectedNode.text);
    const workflowName = useSelector(state => state.treeData[parentScreen].leftTree.tree.body.selectedNode.title);
    const { leftTree} = useSelector((state) => state.treeData[parentScreen]);
    const leftTranslatedData = leftTree.tree.body.translatedData;
    const selectedNode = leftTree.tree.body.selectedNode;
    const [loading, setLoading] = useState(false)
    const [isUserSpace, setIsUserSpace] = useState(false);
    const [isServer, setIsServer] = useState(false);
    const error = useRef(null)
    const handleCancelClick = () => {
        toggle();
    }
    const [location, setLocation] = useState("");

    const revertDeletedWorkflowTemplates = (workflowName) => {
			dispatch(api.endpoints.getUnsavedTemplates.initiate({ account })).then(
				(res) => {
					if (res?.data?.current_state === "SUCCESS") {
						const unsavedTemplates = res.data.data;
						const revertData = {
							inbound_templates: unsavedTemplates?.inbound_templates?.filter(
								(e) => e?.workflow_group === workflowName
							),
							outbound_templates: unsavedTemplates?.outbound_templates?.filter(
								(e) => e?.workflow_group === workflowName
							),
							workflow: unsavedTemplates?.workflow?.filter(
								(e) => e?.workflow_group === workflowName
							),
						};
						dispatch(
							api.endpoints.revertAllTemplates.initiate(
								{ data: revertData },
								{ forceRefetch: true }
							)
						).then(() => {
							dispatch(
								api.endpoints.getUnsavedTemplates.initiate(
									{ account },
									{ forceRefetch: true }
								)
							);
						});
					}
				}
			);
		};


    const handleClick = async () => {
        const wfName = workflowName;
        try {
          setLoading(true)
          const response = await dispatch(
            api.endpoints.deleteWorkflowname.initiate(
              {
                account,
                workflowName,
                is_userspace: isUserSpace,
                is_server: isServer
              },
              { forceRefetch: true }
            )
          );
          // Check if there's an error in the response
          if (response.error) {
            setLoading(false);
            throw new Error(
              response.message || 
              response.error.message || 
              t("BOX_MSG_GENERAL_ERROR")
            );
          }
      
          if (response?.data?.current_state === "SUCCESS") {
            revertDeletedWorkflowTemplates(workflowName);
            setLoading(false)
            dispatch(newTemplateActions.setShowAlert(true));
            dispatch(newTemplateActions.setAlertMessage(response.data.message));
            
             dispatch(
              api.endpoints.getInboundTemplateList.initiate(
                { account },
                { forceRefetch: true }
              )
            ).then((res) => {
              const treeData = res?.data?.data?.workflow_groups || [];
              const wfNode = treeData?.filter(wf => wf.name === wfName)?.[0];
              dispatch(
                treeActions.setLeftTreeContextActionValue({
                  screen: parentScreen,
                  data : {
                    workflowGroup: wfNode ? wfNode?.name : treeData?.length ? treeData[0]?.name : "",
                    tabChanged: false
                  }
                })
              )
            });
             dispatch(
              api.endpoints.getOutboundTemplateList.initiate(
                { account },
                { forceRefetch: true }
              )
            )
            .then((res) => {
              const treeData = res?.data?.data?.workflow_groups || [];
              const wfNode = treeData?.filter(wf => wf.name === wfName)?.[0];
              dispatch(
                treeActions.setLeftTreeContextActionValue({
                  screen: parentScreen,
                  data : {
                    workflowGroup: wfNode ? wfNode?.name : treeData?.length ? treeData[0]?.name : "",
                    tabChanged: false
                  }
                })
              )
            });
            dispatch(
              api.endpoints.getWorkflows.initiate(
                { account },
                { subscribe: false, forceRefetch: true }
              )
            ).then((res) => {
              const treeData = res?.data?.data?.workflow_groups || [];
              const wfNode = treeData?.filter(wf => wf.name === wfName)?.[0];
              dispatch(
                treeActions.setLeftTreeContextActionValue({
                  screen: parentScreen,
                  data : {
                    workflowGroup: wfNode ? wfNode?.name : treeData?.length ? treeData[0]?.name : "",
                    tabChanged: false
                  }
                })
              )
            });
            toggle();
          } else {
            console.warn(response?.data?.message);
            setLoading(false)
            error.current.textContent =
              response?.data?.message || t("BOX_MSG_GENERAL_ERROR");
          }
        } catch (err) {
          setLoading(false)  
          error.current.textContent = err.message || t("BOX_MSG_GENERAL_ERROR");
        }
      };


    useEffect(() => {
      setLocation(selectedNode?.location);
      setIsServer(selectedNode?.location !== "userspace");
      setIsUserSpace(selectedNode?.location !== "server");
    }, [selectedNode])

    return (
        <>
            <Dialog onClose={props.onClose} open={openModal} maxWidth='sm'>
                <DialogTitle className="dialog-header padding-12">
                   <div className='title'> {t('BOX_CONFIRM')} </div>
                </DialogTitle>
                <DialogContent className='modal-content' dividers style={{width: 'unset'}}>
                    {t('WFG_DELETE_WARN')}<br/>
                    <strong>{workflowName}</strong><br/><br/>
                    <div>{t('ARE_YOU_SURE_YOU_WANT_TO_DO_THIS')}</div>
                    <p className='error' ref={error}></p>
                </DialogContent>
                <DialogActions>
                    <div className="flex justify-start width-100">
                        <LabeledCheckbox
                            label={t('USERSPACE')}
                            checked={isUserSpace}
                            disabled={location === "server"}
                            handleCheck={(checked) => {
                                setIsUserSpace(checked);
                            }}
                        />
                        <LabeledCheckbox
                            label={t('SERVER')}
                            checked={isServer}
                            disabled={location === "userspace"}
                            handleCheck={(checked) => {
                                setIsServer(checked);
                            }}
                        />
                    </div>
                    <Button
                        size="small"
                        variant="outlined"
                        color="primary"
                        disabled={loading}
                        onClick={() => handleClick()}
                    > {loading ? <CircularProgress size="20px" color='primary' />: t('BTN_YES')}
                    </Button>
                    <Button
                        size="small"
                        variant="outlined"
                        color="primary"
                        onClick={() => handleCancelClick()}
                    > {t('BTN_NO')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default DeleteWorkflowGroup;